import { render, staticRenderFns } from "./DashboardDataFooter.vue?vue&type=template&id=01b55597&scoped=true&"
import script from "./DashboardDataFooter.vue?vue&type=script&lang=ts&"
export * from "./DashboardDataFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardDataFooter.vue?vue&type=style&index=0&id=01b55597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b55597",
  null
  
)

export default component.exports